import { reduceAction } from '../helpers';

import types from './types';

export const initialState = () => ({
    profile: {},
    loading: false,
    customerStatusDelay: null,
    pendingSubscription: false,
    statusNotUpdated: false,
    showUserPopoverInfo: false,
    loyaltyCheques: [],
    enableForNonVerifiedUser: false,
    disableLoyaltyVouchers: false,
    isVip: false,
});

const reducers = (state = initialState(), action) => {
    switch (action.type) {
        case types.SET_INITIAL_DATA:
            return initialState(state, action.payload || {});
        case types.UPDATE_PROFILE:
        case types.SET_PROFILE:
            return {
                ...state,
                profile: {
                    ...(action.payload
                        ? { ...action.payload, ...(action.payload.uid ? { uid: 'current' } : {}) }
                        : {}),
                },
                isVip:
                    action.payload &&
                    action.payload.vipProgramInformation &&
                    action.payload.vipProgramInformation.tierName === 'VIP',
            };
        case types.SET_WARNING_MESSAGE:
            return reduceAction(state, 'statusNotUpdated', true);
        case types.SET_STATUS_DELAY:
            return reduceAction(state, 'customerStatusDelay', +action.payload);
        case types.SET_STATUS_RETRY:
            return reduceAction(state, 'customerStatusRetry', +action.payload);
        case types.SET_USER_POPOVER_INFO:
            return reduceAction(state, 'showUserPopoverInfo', action.payload);
        case types.SET_STATUS_BEFORE_ATTEMPT_DELAY:
            return reduceAction(state, 'customerStatusBeforeAttemptDelay', +action.payload);
        case types.SET_CHILDREN:
            return {
                ...state,
                profile: {
                    ...state.profile,
                    personalInformation: {
                        ...state.profile.personalInformation,
                        children: action.payload,
                    },
                },
            };
        case types.SET_BABYBORN:
            return {
                ...state,
                profile: {
                    ...state.profile,
                    personalInformation: {
                        ...state.profile.personalInformation,
                        babyborn: action.payload,
                    },
                },
            };
        case types.SET_LOYALTY_CARD:
            return {
                ...state,
                profile: {
                    ...state.profile,
                    loyaltyInformation: {
                        ...state.profile.loyaltyInformation,
                        cardNumber: action.payload,
                    },
                },
            };
        case types.SET_PENDING_SUBSCRIPTION:
            return reduceAction(state, 'pendingSubscription', !!action.payload);
        case types.SET_REGISTERED_ON_CHECKOUT:
            return reduceAction(state, 'isRegisteredOnCheckout', !!action.payload);
        case types.DISMISS_BIRTH_DATE_POPUP:
            return {
                ...state,
                profile: {
                    ...state.profile,
                    preferencesInformation: {
                        ...state.preferencesInformation,
                        dismissedBirthDatePopup: true,
                    },
                },
            };
        case types.LOAD_LOYALTY_CHEQUES:
            return {
                ...state,
                loyaltyCheques: action.payload,
                loyaltyChequesAmount: action.payload.length || 0,
            };
        case types.SET_LAST_VIEWED_PRODUCTS_CLEARED:
            return reduceAction(state, 'lastViewedProductsCleared', true);
        case types.ENABLE_FOR_NON_VERIFIED_USER:
            return reduceAction(state, 'enableForNonVerifiedUser', action.payload);
        case types.DISABLE_LOYALTY_VOUCHER:
            return reduceAction(state, 'disableLoyaltyVouchers', true);
        default:
            return state;
    }
};

export default reducers;
